import { ActionData, ValueType } from '@convergence/types';

export function actionDataFromTreeAndPath(
  tree: ValueType,
  path: string[]
): ActionData | undefined {
  let current: any = tree;
  for (const p of path) {
    current = current?.[p];
  }

  return current?._actionData as ActionData | undefined;
}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function getError(
  errors: { message: string; keyPath: string[] }[],
  propertyPath: string[]
) {
  return errors.find((e) => e.keyPath.join() === propertyPath.join());
}
